/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MeasureIcon = ({ width = 24, height = 24, hidden = false, title = 'Measure' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25.071 2.444 2.444 25.071a1 1 0 0 0 0 1.414l7.071 7.071a1 1 0 0 0 1.414 0l3.535-3.535-5.3-5.3a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .707 0l5.3 5.3 5.657-5.657-3.89-3.889a.5.5 0 0 1 0-.707l.708-.708a.5.5 0 0 1 .707 0l3.889 3.89 5.657-5.657-5.3-5.3a.5.5 0 0 1 0-.707l.707-.707a.5.5 0 0 1 .708 0l5.3 5.3 3.535-3.535a1 1 0 0 0 0-1.414l-7.071-7.072a1 1 0 0 0-1.414 0Z"
    />
  </svg>`;
};
